(function() {
	'use strict';

	angular
		.module('pwc.controllers')
		.controller('PromptSaveDialogController', PromptSaveDialogController);

	PromptSaveDialogController.$inject = ['$mdDialog', 'stateName'];

	function PromptSaveDialogController($mdDialog, stateName){

		/* jshint validthis: true */
		var self = this;

		self.stateName = stateName;

		self.hide = hide;
		self.cancel = cancel;
		self.answer = answer;

		function hide(){
			return $mdDialog.hide();
		}

		function cancel(){
			return $mdDialog.cancel();
		}

		function answer(shouldSave){
			$mdDialog.hide(shouldSave);
		}
	}

})();